module.exports = __webpack_public_path__ + "static/media/semoir.bc7d9101.png";